/* eslint-disable @typescript-eslint/no-unused-vars */
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { AuthGuard } from 'src/auth/guard';
import DashboardLayout from 'src/layouts/dashboard';
import MaintenancePage from 'src/pages/maintenance';
import BarListPage from 'src/pages/dashboard/bar/list';
import BarEditPage from 'src/pages/dashboard/bar/edit';
import MyTasksPage from 'src/pages/dashboard/my-tasks';
import UserListPage from 'src/pages/dashboard/user/list';
import UserEditPage from 'src/pages/dashboard/user/edit';
import BarDetailPage from 'src/pages/dashboard/bar/view';
import LoanListPage from 'src/pages/dashboard/loans/list';
import LoanEditPage from 'src/pages/dashboard/loans/edit';
import UserCreatePage from 'src/pages/dashboard/user/new';
import LoanCreatePage from 'src/pages/dashboard/loans/new';
import UserDetailPage from 'src/pages/dashboard/user/view';
import LoanDetailPage from 'src/pages/dashboard/loans/view';
import BarItemCreatePage from 'src/pages/dashboard/bar/new';
import ChequeListPage from 'src/pages/dashboard/cheque/list';
import ChequeEditPage from 'src/pages/dashboard/cheque/edit';
import ChequeCreatePage from 'src/pages/dashboard/cheque/new';
import KitchenListPage from 'src/pages/dashboard/kitchen/list';
import KitchenEditPage from 'src/pages/dashboard/kitchen/edit';
import ChequeDetailPage from 'src/pages/dashboard/cheque/view';
import KitchenCreatePage from 'src/pages/dashboard/kitchen/new';
import KitchenDetailPage from 'src/pages/dashboard/kitchen/view';
import SupplierEditPage from 'src/pages/dashboard/suppliers/edit';
import OverviewAnalyticsPage from 'src/pages/dashboard/analytics';
import EmployeeListPage from 'src/pages/dashboard/employees/list';
import EmployeeEditPage from 'src/pages/dashboard/employees/edit';
import AuditLogListPage from 'src/pages/dashboard/audit-log/list';
import SuppliersListPage from 'src/pages/dashboard/suppliers/list';
import SupplierCreatePage from 'src/pages/dashboard/suppliers/new';
import EmployeeCreatePage from 'src/pages/dashboard/employees/new';
import SupplierDetailPage from 'src/pages/dashboard/suppliers/view';
import EmployeeDetailPage from 'src/pages/dashboard/employees/view';
import BarPurchaseListPage from 'src/pages/dashboard/bar/purchase/list';
import BarPurchaseCreatePage from 'src/pages/dashboard/bar/purchase/new';
import IssuedChequeEditPage from 'src/pages/dashboard/issued-cheque/edit';
import IssuedChequeListPage from 'src/pages/dashboard/issued-cheque/list';
import IssuedChequeCreatePage from 'src/pages/dashboard/issued-cheque/new';
import IssuedChequeDetailPage from 'src/pages/dashboard/issued-cheque/view';
import PackagingItemListPage from 'src/pages/dashboard/packaging/item/list';
import PackagingItemEditPage from 'src/pages/dashboard/packaging/item/edit';
import PackagingItemViewPage from 'src/pages/dashboard/packaging/item/view';
import BarPurchaseOrderEditPage from 'src/pages/dashboard/bar/purchase/edit';
import BarDispatchOrderEditPage from 'src/pages/dashboard/bar/dispatch/edit';
import PackagingItemCreatePage from 'src/pages/dashboard/packaging/item/new';
import PackagingItemUsagePage from 'src/pages/dashboard/packaging/item/usage';
import BarDispatchOrdersListPage from 'src/pages/dashboard/bar/dispatch/list';
import BarDispatchOrderCreatePage from 'src/pages/dashboard/bar/dispatch/new';
import StationeryItemListPage from 'src/pages/dashboard/stationery/item/list';
import StationeryItemEditPage from 'src/pages/dashboard/stationery/item/edit';
import StationeryItemViewPage from 'src/pages/dashboard/stationery/item/view';
import BarPurchaseOrderDetailPage from 'src/pages/dashboard/bar/purchase/view';
import BarDispatchOrderDetailPage from 'src/pages/dashboard/bar/dispatch/view';
import StationeryItemCreatePage from 'src/pages/dashboard/stationery/item/new';
import KitchenPurchaseListPage from 'src/pages/dashboard/kitchen/purchase/list';
import KitchenDispatchListPage from 'src/pages/dashboard/kitchen/dispatch/list';
import PackagingReturnListPage from 'src/pages/dashboard/packaging/return/list';
import PackagingReturnEditPage from 'src/pages/dashboard/packaging/return/edit';
import PackagingReturnViewPage from 'src/pages/dashboard/packaging/return/view';
import ReorderSettingsListPage from 'src/pages/dashboard/reorder-settings/list';
import KitchenPurchaseCreatePage from 'src/pages/dashboard/kitchen/purchase/new';
import KitchenDispatchCreatePage from 'src/pages/dashboard/kitchen/dispatch/new';
import AdvancedPaymentEditPage from 'src/pages/dashboard/advanced-payments/edit';
import PackagingReturnCreatePage from 'src/pages/dashboard/packaging/return/new';
import PackagingProductListPage from 'src/pages/dashboard/packaging/product/list';
import PackagingProductEditPage from 'src/pages/dashboard/packaging/product/edit';
import FactoringBatchListPage from 'src/pages/dashboard/cheque-factoring/batches';
import AdvancedPaymentsListPage from 'src/pages/dashboard/advanced-payments/list';
import AdvancedPaymentCreatePage from 'src/pages/dashboard/advanced-payments/new';
import StationeryReturnListPage from 'src/pages/dashboard/stationery/return/list';
import StationeryReturnEditPage from 'src/pages/dashboard/stationery/return/edit';
import StationeryReturnViewPage from 'src/pages/dashboard/stationery/return/view';
import PackagingProductCreatePage from 'src/pages/dashboard/packaging/product/new';
import FactoringDebtorListPage from 'src/pages/dashboard/cheque-factoring/debtors';
import StationeryReturnCreatePage from 'src/pages/dashboard/stationery/return/new';
import PackagingDispatchListPage from 'src/pages/dashboard/packaging/dispatch/list';
import PackagingDispatchEditPage from 'src/pages/dashboard/packaging/dispatch/edit';
import PackagingDispatchViewPage from 'src/pages/dashboard/packaging/dispatch/view';
import PackagingDispatchCreatePage from 'src/pages/dashboard/packaging/dispatch/new';
import KitchenPurchaseOrderEditPage from 'src/pages/dashboard/kitchen/purchase/edit';
import KitchenDispatchOrderEditPage from 'src/pages/dashboard/kitchen/dispatch/edit';
import FactoringCandidatesPage from 'src/pages/dashboard/cheque-factoring/candidates';
import StationeryDispatchListPage from 'src/pages/dashboard/stationery/dispatch/list';
import StationeryDispatchEditPage from 'src/pages/dashboard/stationery/dispatch/edit';
import StationeryDispatchViewPage from 'src/pages/dashboard/stationery/dispatch/view';
import FactoringBatchDetailPage from 'src/pages/dashboard/cheque-factoring/batch-view';
import KitchenPurchaseOrderDetailPage from 'src/pages/dashboard/kitchen/purchase/view';
import KitchenDispatchOrderDetailPage from 'src/pages/dashboard/kitchen/dispatch/view';
import StationeryDispatchCreatePage from 'src/pages/dashboard/stationery/dispatch/new';
import PackagingStockCountListPage from 'src/pages/dashboard/packaging/stock-count/list';
import PackagingStockCountViewPage from 'src/pages/dashboard/packaging/stock-count/view';
import PackagingStockCountEditPage from 'src/pages/dashboard/packaging/stock-count/edit';
import PackagingStockCountCreatePage from 'src/pages/dashboard/packaging/stock-count/new';
import FactoringOverdueSettlementsPage from 'src/pages/dashboard/cheque-factoring/overdue';
import StationeryStockCountListPage from 'src/pages/dashboard/stationery/stock-count/list';
import StationeryStockCountViewPage from 'src/pages/dashboard/stationery/stock-count/view';
import StationeryStockCountEditPage from 'src/pages/dashboard/stationery/stock-count/edit';
import StationeryStockCountCreatePage from 'src/pages/dashboard/stationery/stock-count/new';
import PackagingPurchaseOrderListPage from 'src/pages/dashboard/packaging/purchase-order/list';
import PackagingPurchaseOrderEditPage from 'src/pages/dashboard/packaging/purchase-order/edit';
import PackagingPurchaseOrderViewPage from 'src/pages/dashboard/packaging/purchase-order/view';
import PackagingPurchaseOrderCreatePage from 'src/pages/dashboard/packaging/purchase-order/new';
import StationeryPurchaseOrderListPage from 'src/pages/dashboard/stationery/purchase-order/list';
import StationeryPurchaseOrderEditPage from 'src/pages/dashboard/stationery/purchase-order/edit';
import StationeryPurchaseOrderViewPage from 'src/pages/dashboard/stationery/purchase-order/view';
import PackagingDamageDispatchListPage from 'src/pages/dashboard/packaging/damage-dispatch/list';
import PackagingDamageDispatchViewPage from 'src/pages/dashboard/packaging/damage-dispatch/view';
import StationeryPurchaseOrderCreatePage from 'src/pages/dashboard/stationery/purchase-order/new';
import PackagingDamageDispatchCreatePage from 'src/pages/dashboard/packaging/damage-dispatch/new';
import StationeryDamageDispatchListPage from 'src/pages/dashboard/stationery/damage-dispatch/list';
import StationeryDamageDispatchViewPage from 'src/pages/dashboard/stationery/damage-dispatch/view';
import StationeryDamageDispatchCreatePage from 'src/pages/dashboard/stationery/damage-dispatch/new';

import { LoadingScreen } from 'src/components/loading-screen';

export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { path: 'analytics', element: <OverviewAnalyticsPage /> },
      { path: 'my-tasks', element: <MyTasksPage /> },
      {
        path: 'user',
        children: [
          { element: <UserListPage />, index: true },
          { path: 'new', element: <UserCreatePage /> },
          { path: ':id/edit', element: <UserEditPage /> },
          { path: ':id/view', element: <UserDetailPage /> },
        ],
      },
      {
        path: 'kitchen',
        children: [
          { element: <KitchenListPage />, index: true },
          { path: 'new', element: <KitchenCreatePage /> },
          { path: ':id/edit', element: <KitchenEditPage /> },
          { path: ':id/view', element: <KitchenDetailPage /> },
        ],
      },
      {
        path: 'kitchen-purchase',
        children: [
          { element: <KitchenPurchaseListPage />, index: true },
          { path: 'new', element: <KitchenPurchaseCreatePage /> },
          { path: ':id/edit', element: <KitchenPurchaseOrderEditPage /> },
          { path: ':id/view', element: <KitchenPurchaseOrderDetailPage /> },
        ],
      },
      {
        path: 'kitchen-dispatch',
        children: [
          { element: <KitchenDispatchListPage />, index: true },
          { path: 'new', element: <KitchenDispatchCreatePage /> },
          { path: ':id/edit', element: <KitchenDispatchOrderEditPage /> },
          { path: ':id/view', element: <KitchenDispatchOrderDetailPage /> },
        ],
      },
      {
        path: 'bar',
        children: [
          { element: <BarListPage />, index: true },
          { path: 'new', element: <BarItemCreatePage /> },
          { path: ':id/edit', element: <BarEditPage /> },
          { path: ':id/view', element: <BarDetailPage /> },
        ],
      },
      {
        path: 'bar-purchase',
        children: [
          { element: <BarPurchaseListPage />, index: true },
          { path: 'new', element: <BarPurchaseCreatePage /> },
          { path: ':id/view', element: <BarPurchaseOrderDetailPage /> },
          { path: ':id/edit', element: <BarPurchaseOrderEditPage /> },
        ],
      },
      {
        path: 'bar-dispatch',
        children: [
          { element: <BarDispatchOrdersListPage />, index: true },
          { path: 'new', element: <BarDispatchOrderCreatePage /> },
          { path: ':id/view', element: <BarDispatchOrderDetailPage /> },
          { path: ':id/edit', element: <BarDispatchOrderEditPage /> },
        ],
      },
      {
        path: 'cheque',
        children: [
          { element: <ChequeListPage />, index: true },
          { path: 'new', element: <ChequeCreatePage /> },
          { path: ':id/edit', element: <ChequeEditPage /> },
          { path: ':id/view', element: <ChequeDetailPage /> },
        ],
      },
      {
        path: 'issued-cheque',
        children: [
          { element: <IssuedChequeListPage />, index: true },
          { path: 'new', element: <IssuedChequeCreatePage /> },
          { path: ':id/edit', element: <IssuedChequeEditPage /> },
          { path: ':id/view', element: <IssuedChequeDetailPage /> },
        ],
      },
      {
        path: 'cheque-factoring-candidates',
        children: [{ element: <FactoringCandidatesPage />, index: true }],
      },
      {
        path: 'cheque-factoring-batches',
        children: [
          { element: <FactoringBatchListPage />, index: true },
          { path: ':id/view', element: <FactoringBatchDetailPage /> },
        ],
      },
      {
        path: 'cheque-factoring-overdue',
        children: [{ element: <FactoringOverdueSettlementsPage />, index: true }],
      },
      {
        path: 'cheque-factoring-debtors',
        children: [{ element: <FactoringDebtorListPage />, index: true }],
      },
      {
        path: 'suppliers',
        children: [
          { element: <SuppliersListPage />, index: true },
          { path: 'new', element: <SupplierCreatePage /> },
          { path: ':id/edit', element: <SupplierEditPage /> },
          { path: ':id/view', element: <SupplierDetailPage /> },
        ],
      },
      {
        path: 'employees',
        children: [
          { element: <EmployeeListPage />, index: true },
          { path: 'new', element: <EmployeeCreatePage /> },
          { path: ':id/edit', element: <EmployeeEditPage /> },
          { path: ':id/view', element: <EmployeeDetailPage /> },
        ],
      },
      {
        path: 'advanced-payments',
        children: [
          { element: <AdvancedPaymentsListPage />, index: true },
          { path: ':employeeID/new', element: <AdvancedPaymentCreatePage /> },
          { path: ':employeeID/edit/:id', element: <AdvancedPaymentEditPage /> },
        ],
      },
      {
        path: 'loans',
        children: [
          { element: <LoanListPage />, index: true },
          { path: 'new', element: <LoanCreatePage /> },
          { path: ':id/edit', element: <LoanEditPage /> },
          { path: ':id/view', element: <LoanDetailPage /> },
        ],
      },
      {
        path: 'reorder-settings',
        children: [{ element: <ReorderSettingsListPage />, index: true }],
      },
      {
        path: 'audit-log',
        children: [{ element: <AuditLogListPage />, index: true }],
      },
      {
        path: 'packaging-product',
        children: [
          { element: <PackagingProductListPage />, index: true },
          { path: 'new', element: <PackagingProductCreatePage /> },
          { path: ':id/edit', element: <PackagingProductEditPage /> },
        ],
      },
      {
        path: 'packaging-item',
        children: [
          { element: <PackagingItemListPage />, index: true },
          { path: 'new', element: <PackagingItemCreatePage /> },
          { path: 'usage', element: <PackagingItemUsagePage /> },
          { path: ':id/edit', element: <PackagingItemEditPage /> },
          { path: ':id/view', element: <PackagingItemViewPage /> },
        ],
      },
      {
        path: 'packaging-purchase-order',
        children: [
          { element: <PackagingPurchaseOrderListPage />, index: true },
          { path: 'new', element: <PackagingPurchaseOrderCreatePage /> },
          { path: ':id/edit', element: <PackagingPurchaseOrderEditPage /> },
          { path: ':id/view', element: <PackagingPurchaseOrderViewPage /> },
        ],
      },
      {
        path: 'packaging-dispatch',
        children: [
          { element: <PackagingDispatchListPage />, index: true },
          { path: 'new', element: <PackagingDispatchCreatePage /> },
          { path: ':id/edit', element: <PackagingDispatchEditPage /> },
          { path: ':id/view', element: <PackagingDispatchViewPage /> },
        ],
      },
      {
        path: 'packaging-return',
        children: [
          { element: <PackagingReturnListPage />, index: true },
          { path: 'new', element: <PackagingReturnCreatePage /> },
          { path: ':id/edit', element: <PackagingReturnEditPage /> },
          { path: ':id/view', element: <PackagingReturnViewPage /> },
        ],
      },
      {
        path: 'stationery-item',
        children: [
          { element: <StationeryItemListPage />, index: true },
          { path: 'new', element: <StationeryItemCreatePage /> },
          { path: ':id/edit', element: <StationeryItemEditPage /> },
          { path: ':id/view', element: <StationeryItemViewPage /> },
        ],
      },
      {
        path: 'stationery-purchase-order',
        children: [
          { element: <StationeryPurchaseOrderListPage />, index: true },
          { path: 'new', element: <StationeryPurchaseOrderCreatePage /> },
          { path: ':id/edit', element: <StationeryPurchaseOrderEditPage /> },
          { path: ':id/view', element: <StationeryPurchaseOrderViewPage /> },
        ],
      },
      {
        path: 'stationery-dispatch',
        children: [
          { element: <StationeryDispatchListPage />, index: true },
          { path: 'new', element: <StationeryDispatchCreatePage /> },
          { path: ':id/edit', element: <StationeryDispatchEditPage /> },
          { path: ':id/view', element: <StationeryDispatchViewPage /> },
        ],
      },
      {
        path: 'stationery-return',
        children: [
          { element: <StationeryReturnListPage />, index: true },
          { path: 'new', element: <StationeryReturnCreatePage /> },
          { path: ':id/edit', element: <StationeryReturnEditPage /> },
          { path: ':id/view', element: <StationeryReturnViewPage /> },
        ],
      },
      {
        path: 'packaging-stock-count',
        children: [
          { element: <PackagingStockCountListPage />, index: true },
          { path: 'new', element: <PackagingStockCountCreatePage /> },
          { path: ':id/view', element: <PackagingStockCountViewPage /> },
          { path: ':id/edit', element: <PackagingStockCountEditPage /> },
        ],
      },
      {
        path: 'stationery-stock-count',
        children: [
          { element: <StationeryStockCountListPage />, index: true },
          { path: 'new', element: <StationeryStockCountCreatePage /> },
          { path: ':id/view', element: <StationeryStockCountViewPage /> },
          { path: ':id/edit', element: <StationeryStockCountEditPage /> },
        ],
      },
      {
        path: 'packaging-damage-dispatch',
        children: [
          { element: <PackagingDamageDispatchListPage />, index: true },
          { path: 'new', element: <PackagingDamageDispatchCreatePage /> },
          { path: ':id/view', element: <PackagingDamageDispatchViewPage /> },
        ],
      },
      {
        path: 'stationery-damage-dispatch',
        children: [
          { element: <StationeryDamageDispatchListPage />, index: true },
          { path: 'new', element: <StationeryDamageDispatchCreatePage /> },
          { path: ':id/view', element: <StationeryDamageDispatchViewPage /> },
        ],
      },
      {
        path: 'sales',
        children: [{ element: <MaintenancePage />, index: true }],
      },

      // {
      //   path: 'order',
      //   children: [
      //     { element: <OrderListPage />, index: true },
      //     { path: 'list', element: <OrderListPage /> },
      //     { path: ':id', element: <OrderDetailsPage /> },
      //   ],
      // },

      // {
      //   path: 'invoice',
      //   children: [
      //     { element: <InvoiceListPage />, index: true },
      //     { path: 'list', element: <InvoiceListPage /> },
      //     { path: ':id', element: <InvoiceDetailsPage /> },
      //     { path: ':id/edit', element: <InvoiceEditPage /> },
      //     { path: 'new', element: <InvoiceCreatePage /> },
      //   ],
      // },
      // {
      //   path: 'post',
      //   children: [
      //     { element: <BlogPostsPage />, index: true },
      //     { path: 'list', element: <BlogPostsPage /> },
      //     { path: ':title', element: <BlogPostPage /> },
      //     { path: ':title/edit', element: <BlogEditPostPage /> },
      //     { path: 'new', element: <BlogNewPostPage /> },
      //   ],
      // },

      // { path: 'file-manager', element: <FileManagerPage /> },
      // { path: 'mail', element: <MailPage /> },
      // { path: 'chat', element: <ChatPage /> },
      // { path: 'calendar', element: <CalendarPage /> },
      // { path: 'kanban', element: <KanbanPage /> },
    ],
  },
];
